import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import '@/assets/css/slider.css';
Vue.component('VueSlider', VueSlider);